import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Alert, AlertType } from './alert.model';

@Injectable({ providedIn: 'root' })
export class AlertService {
    constructor(private toastr: ToastrService) {}

    // convenience methods — the `options` arg is kept for backwards compatibility
    // with existing call sites but is no longer needed for floating toasts.
    success(message: string, options?: any) {
        this.toastr.success(message);
    }

    error(message: string, options?: any) {
        this.toastr.error(message);
    }

    info(message: string, options?: any) {
        this.toastr.info(message);
    }

    warn(message: string, options?: any) {
        this.toastr.warning(message);
    }

    // main alert method — routes to the matching toast type
    alert(alert: Alert) {
        switch (alert.type) {
            case AlertType.Success:
                this.toastr.success(alert.message);
                break;
            case AlertType.Error:
                this.toastr.error(alert.message);
                break;
            case AlertType.Warning:
                this.toastr.warning(alert.message);
                break;
            case AlertType.Info:
            default:
                this.toastr.info(alert.message);
                break;
        }
    }

    // clear all visible toasts
    clear() {
        this.toastr.clear();
    }
}
